import { shippingZonesClient } from "@core/clients";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { CheckForExpressPayload, ExpressPointsData } from "@core/types";

const useCheckAddressForExpressMutation = (
  options?: UseMutationOptions<ExpressPointsData, any, CheckForExpressPayload>,
) =>
  useMutation(
    ["check-address-for-express"],
    async (address) => {
      return await shippingZonesClient?.getCheckAddressForExpress(address);
    },
    {
      ...options,
    },
  );

export default useCheckAddressForExpressMutation;
